import { TruncatingTextWebElementBase } from './TruncatingTextWebElementBase';

/**
 * The component WebElement for [oj-c-truncating-text](../../../oj-c/docs/oj.TruncatingText.html).
 * Do not instantiate this class directly, instead, use
 * [findTruncatingText](../functions/findTruncatingText.html).
 */
export class TruncatingTextWebElement extends TruncatingTextWebElementBase {
  // Put overrides here
}
